import { render, staticRenderFns } from "./ingredient-table.vue?vue&type=template&id=5237c872&"
import script from "./ingredient-table.vue?vue&type=script&lang=js&"
export * from "./ingredient-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports